package ir.alirezaivaz.finglish.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidedValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.text.intl.Locale
import ir.alirezaivaz.finglish.dto.Language

external object window {
    var __customLocale: String?
}

actual object LocalAppLocale {
    private val LocalAppLocale = staticCompositionLocalOf { Locale.current }
    actual val current: Language
        @Composable get() {
            return Language.find(LocalAppLocale.current.toString())
        }

    @Composable
    actual infix fun provides(value: Language): ProvidedValue<*> {
        set(value)
        val locale = Locale(value.tag)
        return LocalAppLocale.provides(locale)
    }

    actual fun set(value: Language): String {
        SettingsManager.updateLanguage(value)
        val languageTag = value.tag
        window.__customLocale = languageTag.replace('_', '-')
        return languageTag
    }
}
